import Vue from "vue";

import AccountLogout from "@Account/Scripts/Components/Account/AccountLogout.vue";
import ToastHub from "@Account/Scripts/Components/Toast/ToastHub.vue";

import NewsletterSubscribe from "@Scripts/Components/NewsletterSubscribe/NewsletterSubscribe.vue";
import NewsletterSubscribeCta from "@Scripts/Components/NewsletterSubscribe/NewsletterSubscribeCta.vue";

import SearchBox from "@Scripts/Components/Search/SearchBox.vue";
import SearchBoxCta from "@Scripts/Components/Search/SearchBoxCta.vue";

import CartDetail from "@Scripts/Components/Store/Cart/CartDetail.vue";
import CartPreview from "@Scripts/Components/Store/Cart/CartPreview.vue";
import CheckoutProfileEdit from "@Scripts/Components/Store/Checkout/CheckoutProfileEdit.vue";
import CheckoutConfirm from "@Scripts/Components/Store/Checkout/CheckoutConfirm.vue";
import CheckoutSummary from "@Scripts/Components/Store/Checkout/CheckoutSummary.vue";
import ProductDetailAdd from "@Scripts/Components/Store/Product/ProductDetailAdd.vue";
import ShippingAddressList from "@Scripts/Components/Store/ShippingAddress/ShippingAddressList.vue";
import ShippingAddressEdit from "@Scripts/Components/Store/ShippingAddress/ShippingAddressEdit.vue";

import JobOfferList from "@Scripts/Components/JobOffer/JobOfferList.vue";
import JobOfferSubscribe from "@Scripts/Components/JobOffer/JobOfferSubscribe.vue";

import InfoRequest from "@Scripts/Components/InfoRequest/InfoRequest.vue";
import InfoRequestCta from "@Scripts/Components/InfoRequest/InfoRequestCta.vue";
import CookieToast from "@Scripts/Components/CookieToast/CookieToast.vue";

import MagazineList from "@Scripts/Components/Magazine/MagazineList.vue";

import ExpMenu from "@Scripts/Directives/ExpMenu/ExpMenu";

export default class AppConfig {
    public static AddComponents() {
        Vue.component("app-accountlogout", AccountLogout);
        Vue.component("app-toasthub", ToastHub);

        Vue.component("app-newsletter-subscribe", NewsletterSubscribe);
        Vue.component("app-newsletter-subscribe-cta", NewsletterSubscribeCta);

        Vue.component("app-searchbox", SearchBox);
        Vue.component("app-searchboxcta", SearchBoxCta);

        Vue.component("app-cartdetail", CartDetail);
        Vue.component("app-cartpreview", CartPreview);
        Vue.component("app-checkoutprofileedit", CheckoutProfileEdit);
        Vue.component("app-checkoutsummary", CheckoutSummary);
        Vue.component("app-checkout-confirm", CheckoutConfirm);
        Vue.component("app-productdetailadd", ProductDetailAdd);
        Vue.component("app-shippingaddresslist", ShippingAddressList);
        Vue.component("app-shippingaddressedit", ShippingAddressEdit);

        Vue.component("app-jobofferlist", JobOfferList);
        Vue.component("app-joboffersubscribe", JobOfferSubscribe);

        Vue.component("app-inforequest", InfoRequest);
        Vue.component("app-inforequestcta", InfoRequestCta);
        Vue.component("app-cookietoast", CookieToast);

        Vue.component("app-magazinelist", MagazineList);
    }

    public static AddDirectives() {
        Vue.directive("exp-menu", ExpMenu);
    }
}